import { Database, RefreshCw } from 'lucide-react'
import { NavLink, useLocation } from 'react-router-dom'
import { PeriodControl } from './PeriodControl'
import { usePeriodSelection } from '../hooks/usePeriodSelection'

export function AppHeader() {
  const { selection, setSelection } = usePeriodSelection()
  const location = useLocation()
  const live = __DASHBOARD_DATA_MODE__ === 'live'
  const staging = import.meta.env.VITE_DEPLOYMENT_ENV === 'staging'

  return (
    <header className="app-header">
      <div className="brand-lockup">
        <span className="lane-mark" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
        <span className="brand-name">Weighing Station Oversight</span>
      </div>
      <nav className="primary-nav" aria-label="Primary navigation">
        <NavLink to={{ pathname: '/', search: location.search }} end>
          Network
        </NavLink>
        <NavLink to={{ pathname: '/stations/station-01', search: location.search }}>
          Station reports
        </NavLink>
      </nav>
      <div className="header-utilities">
        <span className="demo-label"><Database aria-hidden="true" size={15} /> {staging ? 'Staging · synthetic data' : live ? 'Live station data' : 'Demo data'}</span>
        <span className="last-sync"><RefreshCw aria-hidden="true" size={15} /> {live ? 'Refreshes every second' : 'Sample dataset'}</span>
        <PeriodControl selection={selection} onChange={setSelection} />
      </div>
    </header>
  )
}
